import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Axios from "axios";
import { getAuthStorage } from "../api/service-localstorage"; // import LoginOutInstance from '@/components/loginout/main.js'

var http = Axios.create({
  timeout: 60000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});

var get = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = domainReplace(url); // try {

            _context.next = 3;
            return http.get("https://japi.istrongcloud.com/api/v1/interfaceForwarding/getData", {
              params: {
                url: encodeURI(url + getParams(params))
              },
              headers: {
                companyId: getAuthStorage().projectId || "",
                cookies: getAuthStorage().cookies || "",
                accesstoken: getAuthStorage().accesstoken || ""
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var post = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = domainReplace(url); // try {

            _context2.next = 3;
            return http.post("https://japi.istrongcloud.com/api/v1/interfaceForwarding/postData", {
              url: url,
              param: params
            }, {
              headers: {
                companyId: getAuthStorage().projectId || "",
                cookies: getAuthStorage().cookies || "",
                accesstoken: getAuthStorage().accesstoken || ""
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function post(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getStaticData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = domainReplace(url); // try {

            _context3.next = 3;
            return http.get("https://japi.istrongcloud.com/api/v1/interfaceForwarding/getStaticData", {
              params: {
                url: encodeURI(url + getParams(params))
              },
              headers: {
                companyId: getAuthStorage().projectId || "",
                cookies: getAuthStorage().cookies || "",
                accesstoken: getAuthStorage().accesstoken || ""
              }
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getStaticData(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}(); // 登录接口


var loginVerification = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = domainReplace(url);
            _context4.next = 3;
            return http.post("https://japi.istrongcloud.com/api/v1/interfaceForwarding/doNotVerify", {
              url: url,
              param: params
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function loginVerification(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}(); // 平台部使用的登录接口


var ptLoginVerification = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = domainReplace(url);
            _context5.next = 3;
            return http.post("https://japi.istrongcloud.com/api/v1/interfaceForwarding/doOneAuthLogin", {
              url: url,
              param: params
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function ptLoginVerification(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}(); // 对象转成url参数


function getParams(params) {
  if (!params) return "";
  var paramStr = "";
  Object.keys(params).forEach(function (item) {
    if (paramStr === "") {
      paramStr = "?".concat(item, "=").concat(params[item]);
    } else {
      paramStr = "".concat(paramStr, "&").concat(item, "=").concat(params[item]);
    }
  });
  return paramStr;
} // 域名替换


function domainReplace(url) {
  var result = '';

  if (url.includes('https://datacenter.istrongcloud.com')) {
    result = url.replace('https://datacenter.istrongcloud.com', 'https://dct.istrongcloud.com');
  } else if (url.includes('https://tfzb.istrongcloud.com')) {
    result = url.replace('https://tfzb.istrongcloud.com', 'https://zzzz.istrongcloud.com');
  } else if (url.includes('https://zzhecapi.istrongcloud.com')) {
    result = url.replace('https://zzhecapi.istrongcloud.com', 'https://hhhh.istrongcloud.com');
  }

  return result || url;
}

export default {
  get: get,
  post: post,
  getStaticData: getStaticData,
  loginVerification: loginVerification,
  ptLoginVerification: ptLoginVerification
};